<template>
    
    <div class="dialog-cover">
        
        <div class="puzzle-preparation-dialog-container"> 
            
            <div style="margin-bottom: 0.5rem">观察原图</div>

            <div class="triangle" style="margin-bottom: 0.5rem"></div>

            <img :src="imgUrl" class="ppdc-image" style="margin-bottom: 2.5rem" />

            <div style="margin-bottom: 1rem">我准备好了</div>

            <img :src="images.startBtn" class="ppdc-start-btn" @click="closePreparationDialog" />
        </div>
    </div>
</template>

<script>

    import { computed, reactive, toRefs } from 'vue';

    import startBtn from "@/assets/puzzle/start-btn.png";

    export default {
        name: "PuzzlePreparationDialog",
        props: {
            imageId: {
                type: String
            },
            closePreparationDialog: {
                type: Function
            }
        },
        setup(props) {

            const state = reactive({
                images: {
                    startBtn
                }
            })

            const imgUrl = computed(() => {
                return `./puzzleimage/${props.imageId}/${props.imageId.split("-")[1]}.jpg`;
            });

            return {
                ...toRefs(state),
                imgUrl
            }
        }
    };
</script>

<style lang="scss" scoped>

    .puzzle-preparation-dialog-container {

        color: white;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        width: 100%;
        height: 100%;
        font-weight: 500;
        letter-spacing: 0.1rem;
        font-size: 1.1rem;

        .ppdc-image {
            width: 84%;
            border-radius: 20px;
            border: 5px solid white;
        }

        .ppdc-start-btn {
            width: 10rem;
        }
    }

    .triangle {
        border-top: 10px solid white;
        border-left: 10px solid transparent;
        border-right: 10px solid transparent;
    }
</style>